import * as types from "./constant"

const INIT_STATE = {
    loading: false,
    error: null,

    addMutualFund: null,
    updateMutualFund: null,

    customerMutualFunds: [],
    singleMutualFund: null,

    mutualFundReport: [],
}

const mutualFundReducer = (state = INIT_STATE, action) => {
    switch (action.type) {

    // ADD MUTUAL FUND
    case types.ADD_MUTUAL_FUND_START:
        return {
            ...state,
            loading: true,
            error: null,
        }

    case types.ADD_MUTUAL_FUND_SUCCESS:
        return {
            ...state,
            loading: false,
            addMutualFund: action.payload,
        }

    case types.ADD_MUTUAL_FUND_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        }

    case types.ADD_MUTUAL_FUND_RESET:
        return {
            ...state,
            addMutualFund: null,
        }

    // UPDATE MUTUAL FUND
    case types.UPDATE_MUTUAL_FUND_START:
        return {
            ...state,
            loading: true,
            error: null,
        }

    case types.UPDATE_MUTUAL_FUND_SUCCESS:
        return {
            ...state,
            loading: false,
            updateMutualFund: true,
        }

    case types.UPDATE_MUTUAL_FUND_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        }

    case types.UPDATE_MUTUAL_FUND_RESET:
        return {
            ...state,
            updateMutualFund: null,
        }


    // VIEW CUSTOMER MUTUAL FUNDS
    case types.VIEW_CUSTOMER_MUTUAL_FUND_START:
    return {
        ...state,
        loading: true,
    }

    case types.VIEW_CUSTOMER_MUTUAL_FUND_SUCCESS:
    return {
        ...state,
        loading: false,
        customerMutualFunds: action.payload || [],
    }

    case types.VIEW_CUSTOMER_MUTUAL_FUND_FAILURE:
    return {
        ...state,
        loading: false,
        error: action.payload,
    }
    case types.VIEW_CUSTOMER_MUTUAL_FUND_RESET:
        return {
            ...state,
            customerMutualFunds: [],
        }


    // VIEW SINGLE MUTUAL FUND
    case types.VIEW_SINGLE_MUTUAL_FUND_START:
        return {
            ...state,
            loading: true,
        }

    case types.VIEW_SINGLE_MUTUAL_FUND_SUCCESS:
        return {
            ...state,
            loading: false,
            singleMutualFund: action.payload,
        }

    case types.VIEW_SINGLE_MUTUAL_FUND_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        }

    case types.VIEW_SINGLE_MUTUAL_FUND_RESET:
        return {
            ...state,
            singleMutualFund: null,
        }

    case types.MUTUAL_FUND_REPORT_START:
        return {
            ...state,
            loading: true,
            error: null,
        };

    case types.MUTUAL_FUND_REPORT_SUCCESS:
        return {
            ...state,
            loading: false,
            mutualFundReport: action.payload || [],
        };

    case types.MUTUAL_FUND_REPORT_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        };

    case types.MUTUAL_FUND_REPORT_RESET:
        return {
            ...state,
            mutualFundReport: [],
        };

    default:
      return state
    }
}

export default mutualFundReducer